import { css } from '@emotion/core'

export default ({ theme: { typography, colors } }) => {
  return css`
    /*** coupled to this DOM structure:

    .main-container
      .breadcrumbs row
      .heading row
      .category-slider row
      .product-list-actions row
        .refine-trigger
        .sorting-button
      .product-list-wrapper row
        .spinner'
        .product-list
      .pagination row

  ***/

    .topbar {
      margin-bottom: 1rem;
    }

    .product-list-actions {
      display: flex;
      justify-content: space-between;
      > * {
        width: 100%;
      }
    }

    .filter-trigger {
      appearance: none;
      border-radius: unset;
      text-transform: uppercase;
      font-family: ${typography.headings.fontFamily};
      font-weight: bold;
      display: inline-block;
      padding: 0.5rem 3rem;
      margin-bottom: 1rem;
      height: 40px;
      width: 100%;
      vertical-align: middle;
      text-align: center;
      line-height: 1em;
      border: 1px solid ${colors.active};
      background-color: ${colors.active};
      color: ${colors.complementary.primary};
    }

    .row {
      margin-bottom: 2rem;
    }

    /** mobile filter panels **/
    .dialog-title {
      position: relative;
      height: 10%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .close-modal {
      position: absolute;
      right: 1rem;
      top: 1rem;
      width: 1.5rem;
      height: 1.5rem;
    }

    .mobile-filters {
      height: 80%;
      .list {
        max-height: 65vh;
      }
    }

    .list {
      max-height: 300px;
    }

    .filter-btn-wrapper {
      height: 10%;
      display: flex;
      justify-content: space-around;
      align-items: center;
    }

    .filter-btn {
      width: 45%;
      height: 2.5rem;
    }
  `
}
